import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import Cookies from 'js-cookie'
import { BASE_URL, NAME } from './apiConfig'

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const token = Cookies.get('WEB_SSR')

  useEffect(() => {
    document.title = `${NAME.charAt(0).toUpperCase() + NAME.slice(1)} | Gestion stock`;
    
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = `/${NAME}-fav.png`;
    }
  }, []);

  const fetchUser = useCallback(async () => {
    if (!token) {
      setUser(null)
      setLoading(false)
      return
    }
    try {
      const res = await axios.get(`${BASE_URL}/api/me`, {
        headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
      })
      if (res.data.success) {
        setUser(res.data.data)
      }
    } catch {
      setUser(null)
    } finally {
      setLoading(false)
    }
  }, [token])

  useEffect(() => { fetchUser() }, [fetchUser])

  const can = useCallback((permission) => {
    if (!user || !user.role || !user.role.permissions) return false
    return user.role.permissions.some(p => p.name === permission)
  }, [user])

  const isAdmin = user?.role?.name === 'Admin'

  const logout = useCallback(() => {
    Cookies.remove('WEB_SSR')
    setUser(null)
  }, [])

  return (
    <AuthContext.Provider value={{ user, setUser, loading, can, isAdmin, fetchUser, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}

export default AuthContext
